const initialState = {
  data: null,
  fetching: false,
  fetchingMore: false,
  canFetchMore: true,

  fetched: false,
  error: null,
  loading: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'MY_PAYOUTS_FETCH_PENDING': {
      return {
        ...state,
        fetching: true,
      }
    }

    case 'MY_PAYOUTS_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        error: true,
      }
    }

    case 'MY_PAYOUTS_FETCH_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
      }
    }

    case 'MY_PAYOUTS_FETCH_MORE_PENDING': {
      return {
        ...state,
        fetchingMore: true,
      }
    }

    case 'MY_PAYOUTS_FETCH_MORE_REJECTED': {
      return {
        ...state,
        fetchingMore: false,
        canFetchMore: false,
      }
    }

    case 'MY_PAYOUTS_FETCH_MORE_FULFILLED': {
      return {
        ...state,
        fetchingMore: false,
        fetched: true,

        canFetchMore: action.payload.data.length > 0,
        data: state.data.concat(action.payload.data),
      }
    }

    default: {
      return state
    }
  }
}
